import { createSelector } from "@reduxjs/toolkit";
import { DEFAULT_AUTOSAVE_INTERVAL_SECONDS } from "constants/add-in";

export const selectAddInAuth = (state) => state?.addIn?.authentication;

export const selectAddInAccessToken = createSelector(
  [selectAddInAuth],
  (authentication) => authentication?.accessToken
);

export const selectAddInIsLoggedIn = createSelector(
  [selectAddInAuth],
  (authentication) => Boolean(authentication?.accessToken)
);

export const selectAddInIsInitialized = createSelector(
  [selectAddInAuth],
  (authentication) => Boolean(authentication?.isInitialized)
);

export const selectAddInUsername = createSelector(
  [selectAddInAuth],
  (authentication) => authentication?.username
);

export const selectAddInRefreshToken = createSelector(
  [selectAddInAuth],
  (authentication) => authentication?.refreshToken
);

// null while unresolved — the login screen renders nothing until this is known.
export const selectIsAddInSsoEnabled = createSelector(
  [selectAddInAuth],
  (authentication) => authentication?.ssoEnabled ?? null
);

export const selectCurrentWorkspaceId = createSelector(
  [selectAddInAuth],
  (authentication) => authentication?.currentWorkspaceId
);

export const selectMyWorkspaces = createSelector(
  [selectAddInAuth],
  (authentication) => authentication.workspaces || []
);

export const selectHasMultipleWorkspaces = createSelector(
  [selectMyWorkspaces],
  (workspaces) => workspaces.length > 1
);

export const selectIsAutosaveEnabled = createSelector(
  [selectAddInAuth],
  (authentication) => authentication?.autosaveEnabled !== false
);

const MS_PER_SECOND = 1000;

export const selectAutosaveIntervalMs = createSelector(
  [selectAddInAuth],
  (authentication) => {
    const seconds = authentication?.autosaveIntervalSeconds;
    const resolved =
      Number.isFinite(seconds) && seconds > 0
        ? seconds
        : DEFAULT_AUTOSAVE_INTERVAL_SECONDS;
    return resolved * MS_PER_SECOND;
  }
);
